module.exports = __webpack_public_path__ + "static/media/toldos-y-persianas.4d5763bd.png";